<template>
  <FormContainer>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_206"
          v-model="attestationResteChargeContributionModel"
          label="En cas de reste à charge sur votre dossier, souhaitez-vous qu’il soit pris en charge ?"
          :required="meta.financement?.attestationResteChargeContribution?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.attestationResteChargeContribution?.$messageErreurDirty!"
          :disabled="meta.financement?.attestationResteChargeContribution?.$status === PropertyStatus.NotPresent"
          :items="OuiOuNon"
          :readonly
          nbMaxLines="2"
          class="col-12 col-md-18 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_207"
          v-if="meta.financement?.modePriseEnChargeReste?.$status !== PropertyStatus.NotPresent"
          v-model="modePriseEnChargeResteModel"
          label="Le reste à charge doit être pris sur votre contribution :"
          :required="meta.financement?.modePriseEnChargeReste?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.modePriseEnChargeReste?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="resteChargeContribution"
          :readonly
          force-value
        />
        <WrapperDropdown
          v-else
          id="field_207"
          label="Le reste à charge doit être pris sur votre contribution :"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    ResteChargeContributionTypePublicInterimaireStagiaireCDI,
    ResteChargeContributionTypePublicInterimaire,
    ResteChargeContributionTypePublicPermanent,
  } from '@/features/domaine/types/opco/Demande/AF/ResteChargeContribution'
  import { ResteChargeContributionLibelle } from '@/features/domaine/types/opco/Demande/shared/ResteChargeContribution'
  import { arrayToDropdownItems, OuiOuNon } from '@/features/interface/shared/tools'
  import type { DropdownItem } from '@designSystem/index'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'
  import FormContainer from '../../../shared/components/FormContainer.vue'
  import { useDemandeAFStore } from '../../useDemandeAFStore'

  const store = useDemandeAFStore()
  const { setupFieldWithKey, setupFieldWithOptions } = store
  const { readonly, meta, model } = storeToRefs(store)

  const modePriseEnChargeResteModel = setupFieldWithKey<string | null>('financement.modePriseEnChargeReste')

  const attestationResteChargeContributionModel = setupFieldWithOptions<boolean | null>({
    getValue: (m) => m.financement?.attestationResteChargeContribution ?? null,
    setPatch(patch, value) {
      // Set la valeur
      if (!patch.financement) patch.financement = {}
      patch.financement.attestationResteChargeContribution = value

      // Définie une valeur par défaut si besoin
      if (value && !patch.financement.modePriseEnChargeReste) {
        patch.financement.modePriseEnChargeReste =
          resteChargeContribution.value.find((i) => i.label === 'Investissement')?.id ??
          resteChargeContribution.value.at(0)?.id ??
          null
      }
    },
  })

  const resteChargeContribution = computed<DropdownItem<string>[]>(() => {
    if (model.value?.typePublic === 'Permanent')
      return arrayToDropdownItems(ResteChargeContributionTypePublicPermanent, ResteChargeContributionLibelle)
    else if (model.value?.salaries?.some((s) => s.natureContrat === 'TravailTemporaireCdi')) {
      return arrayToDropdownItems(
        ResteChargeContributionTypePublicInterimaireStagiaireCDI,
        ResteChargeContributionLibelle,
      )
    }
    return arrayToDropdownItems(ResteChargeContributionTypePublicInterimaire, ResteChargeContributionLibelle)
  })
</script>
